import React, { useContext } from 'react';
import SubHeader from '../SubHeader/SubHeader';
import { AppContext } from 'App.context';
import useBookingSummaryHook from './BookingSummary.hook';
import { ReactComponent as PersonIcon } from 'assets/images/person-icon.svg';

import './BookingSummary.css';

export default function BookingSummary({ onNext, isLoading }) {
  const {
    appActions: { getSelectedHotel, translate },
  } = useContext(AppContext);
  const { state, actions } = useBookingSummaryHook();
  const { guestsDetails, rooms } = state;
  let adults = 0;
  let children = 0;
  let price = 0;
  if (rooms) {
    for (const room of rooms) {
      for (const booking of room.bookings) {
        adults += booking.adults;
        children += booking.children;
      }
      price += room.price * room.booked;
    }
  }
  return (
    <>
      <SubHeader
        hotelName={getSelectedHotel()?.name}
        showNext={state.isValid}
        onNext={onNext}
        nextText={translate('createBooking.finalize')}
        isLoading={isLoading}
      />
      <div class="booking-summary-container ">
        <div class="column">
          <div class="info-panel box1">
            <span className="title">
              {translate('createBooking.steps.bookingSummary.guestDetails.title')}
            </span>
            <div className="content">
              <span className="key">
                {translate('createBooking.steps.bookingSummary.guestDetails.name')}
              </span>
              <span className="value">{`${guestsDetails?.name} ${guestsDetails?.surname}`}</span>
              <span className="key">
                {translate('createBooking.steps.bookingSummary.guestDetails.email')}
              </span>
              <span className="value">{`${guestsDetails?.email}`}</span>
              {/* Commented code for when we can make WhatsApp communications
              <span className="key">
                {translate('createBooking.steps.bookingSummary.guestDetails.phone')}
              </span>
              <span className="value">{`${guestsDetails?.phone}`}</span> */}
            </div>
          </div>
          <div class="info-panel box2">
            <span className="title">
              {translate('createBooking.steps.bookingSummary.booking.title')}
            </span>
            <div className="content">
              <span className="value">
                <PersonIcon className="booking-summary-icon" />x{adults}{' '}
                {translate(
                  `createBooking.steps.bookingSummary.booking.${adults === 1 ? 'adult' : 'adults'}`
                )}
              </span>
              <span className="value">
                <PersonIcon className="booking-summary-icon" />x{children}{' '}
                {translate(
                  `createBooking.steps.bookingSummary.booking.${
                    children === 1 ? 'child' : 'children'
                  }`
                )}
              </span>
            </div>
          </div>
        </div>
        <div class="info-panel box3">
          <span className="title">
            {translate('createBooking.steps.bookingSummary.payment.title')}
          </span>
          <div className="content">
            <div className="payment-container">
              <div className="payment-concept">
                {translate('createBooking.steps.bookingSummary.payment.concept')}
              </div>
              <div className="payment-price">
                {translate('createBooking.steps.bookingSummary.payment.price')}
              </div>
            </div>
            <hr />
            <div className="payment-container">
              <div className="payment-concept">
                {translate('createBooking.steps.bookingSummary.payment.subtotal')}
              </div>
              <div className="payment-price">{price.toFixed(2)} €</div>
            </div>
            <div className="payment-container">
              <div className="payment-concept strong">
                {translate('createBooking.steps.bookingSummary.payment.total')}
              </div>
              <div className="payment-price strong">{price.toFixed(2)} €</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
